import type { Components } from '@mui/material/styles';

export default function MUIFormGroup(): Components['MuiFormGroup'] {
  return {};
}
